import type { BasePageConfig } from '@/pageConfig/BasePageConfig';
import ogImage from '@/static/assets/home/og-nl.png';

export const config: BasePageConfig = {
  seo: {
    title: 'Lemonade Buildings, Contents Insurance, & Liability Insurance',
    metaTitle: 'Lemonade Buildings, Contents Insurance, & Liability Insurance',
    description:
      'Lemonade offers buildings, contents, and personal liability insurance, powered by tech and driven by social good. Zero paperwork and instant everything.',
    ogImage: ogImage.src,
  },
  layout: {
    headerActions: {
      dropdown: {
        logout: 'Log out',
        myAccount: 'My Account',
        settings: 'Settings',
      },
      CTAs: {
        backToYourQuote: {
          long: {
            singular: 'Back to your quote',
            plural: 'Back to your quotes',
          },
          short: {
            singular: 'Quote',
            plural: 'Quotes',
          },
        },
        checkOurPrices: {
          long: {
            singular: 'Check our prices',
            plural: 'Check our prices',
          },
          short: {
            singular: 'Price',
            plural: 'Prices',
          },
        },
      },
    },
  },
};
